/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmTriggerV1TriggerQueryServiceTriggerGetResponse, IxmTriggerV1TriggerQueryServiceTriggerGetTriggerGetRequest } from '@interxfi/types';

export const IXM_TRIGGER_V1_TRIGGER_QUERY_SERVICE_TRIGGER_GET_AUDIENCE = ['clearing', 'o5'];

export async function ixmTriggerV1TriggerQueryServiceTriggerGet(baseUrl: string | undefined, request?: IxmTriggerV1TriggerQueryServiceTriggerGetTriggerGetRequest, requestInit?: RequestInit): Promise<IxmTriggerV1TriggerQueryServiceTriggerGetResponse | undefined> { return makeRequest<IxmTriggerV1TriggerQueryServiceTriggerGetResponse, IxmTriggerV1TriggerQueryServiceTriggerGetTriggerGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixm/trigger/v1/trigger/q/:triggerId', request, requestInit)); }

